import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import apiAuth from "constants/api/apiAuth";

export default function ChangePasswordForm(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  function submit(value) {
    setLoading(true);
    apiAuth
      .forgotPassword(value.email)
      .then((res) => {
        if (res?.success) {
          message.success(res?.message);
          form.resetFields();
          props.onFinish();
          return;
        }
        message.error(res?.message ?? "An error occured", 3);
      })
      .catch((err) => {
        message.error(`An error occured: ${err?.message}`, 3);
      })
      .finally(() => setLoading(false));
  }

  return (
    <Form
      name="forgotPasswordForm"
      layout="vertical"
      form={form}
      onFinish={submit}
    >
      <p style={{  fontWeight: "lighter" }}>
        Please ensure that your email is active
      </p>
      <Form.Item
        name="email"
        label="Email"
        rules={[
          {
            required: true,
            message: "Please input your email!",
          },
          {
            type: "email",
            message: "Email is not valid",
          },
        ]}
      >
        <Input placeholder="example@mail.com" />
      </Form.Item>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          style={{ minWidth: "120Px" }}
          loading={loading}
        >
          Reset password
        </Button>
      </Form.Item>
    </Form>
  );
}
